import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { list, checkupSave } from "../../requests/session";
import { createSignal } from "solid-js";

export default function useCheckupSession(props) {

  const [sessions, setSessions] = createSignal([]);

  const [sessionForm, setSessionForm] = createStore({
    sessions: props.sessions || [],
    sessionId: null,
  });

  const { successToast, errorToast } = useApplication();

  const addSession = () => {
    if (!sessionForm.sessionId) {
      errorToast("Please select a session");
      return;
    }

    const exist = sessionForm.sessions.find(session => session.sessionId === sessionForm.sessionId);
    if (exist) {
      errorToast("Session already added");
      return;
    }

    const session = sessions().find(session => session.value === sessionForm.sessionId);
    if (!session) {
      errorToast("Session not found");
      return;
    }

    setSessionForm('sessions', [...sessionForm.sessions, {
      key: crypto.randomUUID(),
      uid: null,
      sessionId: sessionForm.sessionId,
      name: session.text,
    }]);

    sessionForm.sessionId = null;
  }

  const removeSession = (key) => {
    setSessionForm('sessions', sessionForm.sessions.filter(session => session.key !== key));
  }

  const onFetchSessions = async () => {
    try {
      const data = await list();
      setSessions(data.list || []);
    } catch(error) {
      setSessions([]);
    }
  }

  const onSaveSession = async () => {

    props.setLoading(true);
    try {
      const formData = new FormData();
      formData.append('sessions', JSON.stringify(sessionForm.sessions));

      const data = await checkupSave(formData);

      if (data.success) {
        successToast(data.message || "Session saved successfully");
      } else {
        errorToast(data.message || "Failed to save session");
      }
    } catch(error) {
      errorToast("Failed to save session");
    } finally {
      props.setLoading(false);
    }
  }

  const handleSessionInput = (name, value) => {
    setSessionForm([name], value);
  };

  return {
    sessions,
    sessionForm,
    onSaveSession,
    handleSessionInput,
    onFetchSessions,
    addSession,
    removeSession,
  };
}
